import { render, staticRenderFns } from "./index-details.vue?vue&type=template&id=23d4cbbe&scoped=true&"
import script from "./index-details.vue?vue&type=script&lang=js&"
export * from "./index-details.vue?vue&type=script&lang=js&"
import style0 from "./index-details.vue?vue&type=style&index=0&id=23d4cbbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d4cbbe",
  null
  
)

export default component.exports